import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class cbadashboardService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;  

  getnewreccount(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getnewreccount/');
  };

  batchcreation(input: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/CBADashboardApi/createBatch', input, { headers: header, observe: 'response' });
  };

  getAllBatch(itemsPerPageBatch:any,pagenumber:any,mode:any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getAllBatch/'+itemsPerPageBatch+'/'+pagenumber+'/'+mode);
  };
  getAllBatchCount(itemsPerPageBatch:any,pagenumber:any,mode:any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getAllBatchCount/'+itemsPerPageBatch+'/'+pagenumber+'/'+mode);
  };


  downloadBatchFile(batchData:any):Observable<any>{
    return this.httpClient.post<any>(this.baseUrl + 'api/CBADashboardApi/DownloadBatchFile', batchData, { headers: header, observe: 'response' });
  };

  getBatchPendingFiles(batchid: any,itemsPerPage:any,pagenumber:any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getBatchPendingFiles/' + batchid+ '/'+itemsPerPage + '/'+ pagenumber);
  };
  getBatchPendingFilescount(batchid: any,itemsPerPage:any,pagenumber:any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getBatchPendingFilescount/' + batchid+ '/'+itemsPerPage + '/'+ pagenumber);
  };

  UploadCSVFile(formData:FormData): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/CBADashboardApi/UploadCSVFile', formData, {  observe: 'response' })
  }

  uploadXMLToSFTP(input:any):Observable<any>{
    return this.httpClient.post<any>(this.baseUrl + 'api/CBADashboardApi/uploadXMLToSFTP', input, { headers: header, observe: 'response' });
  };

  batchCompletion(input:any):Observable<any>{
    return this.httpClient.post<any>(this.baseUrl + 'api/CBADashboardApi/BatchCompletion', input, { headers: header, observe: 'response' });
  };

  getpendinglistacrnbybatchid(batchid: any): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/CBADashboardApi/getpendinglistacrnbybatchid/' + batchid);
  };
}
